import React from 'react';
import {NavLink, Link} from "react-router-dom";
import {Helmet} from "react-helmet";
import metatags from '../static/metatags';
class Billing extends React.Component {
  constructor(props){
    super(props);
    this.state = {
    }
  }
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  CMXRewards = () => {
    if(this.props.state.redirectfromapp){
      window
      .open(
        "https://www.cmxcinemas.com/rewards",
        "_blank" // <- This is what makes it open in a new window.
      )
      .focus();
    }else{
      window.CMXRewardsExternalURL()
    }
  };

  render() {
    return (
      <section className="cmx-billing-page">
        <Helmet>
          <title>{metatags.commonMetatag.title}</title>
          <meta name="description" content={metatags.commonMetatag.description} />
        </Helmet>
        <section className="row">
            <section className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <aside className='head text-center pt-4 pb-4'>
                <h1><span className='txt-top d-block'>Choose your billing cycle</span></h1>
              </aside>
              <section className='bill-container'>
                <section className='billing-blk'>
                  <ul className='row'>
                    <li className={`col-md-6 col-sm-12 col-12 ${this.props.state.annually_ActiveClass ? 'active':''}`}>
                      <aside className='content' onClick={(e) => this.props.choosePlans(e, (this.props.getPrice(this.props.state.billingGetPriceObj[0].monThu, this.props.state.billingGetPriceObj[0].allday, this.props.state.billingGetPriceObj[0].visits, this.props.state.billingGetPriceObj[0].guests, 'annually', this.props.state.billingGetPriceObj[0].type)), 'annually')}>
                        <span className='fav'>Best Value</span>
                        <h2>Annual 
                          {
                            this.props.state.billingGetPriceObj.length > 0 &&
                            <span>
                              {/* divided / 12 */}
                              ${(this.props.getPrice(this.props.state.billingGetPriceObj[0].monThu, this.props.state.billingGetPriceObj[0].allday, this.props.state.billingGetPriceObj[0].visits, this.props.state.billingGetPriceObj[0].guests, 'annually', this.props.state.billingGetPriceObj[0].type) / 12).toFixed(2)}
                              <i>/mo</i>
                              <small>(${this.props.getPrice(this.props.state.billingGetPriceObj[0].monThu, this.props.state.billingGetPriceObj[0].allday, this.props.state.billingGetPriceObj[0].visits, this.props.state.billingGetPriceObj[0].guests, 'annually', this.props.state.billingGetPriceObj[0].type)} Billed annually)</small>
                            </span>
                          }
                        </h2>
                        <p>Get a free upgrade to a DIAMOND Membership and earn 3x more rewards for your purchases in CMX Rewards</p>
                        <p>No convenience or blockbuster fees and no upgrade charges to watch 3D, PLF, and Dolby ATMOS<sup>2</sup></p>
                        <p>10% Food and Beverage Discount<sup>3</sup></p>
                        <p className='text-center'><a href='javascript:;' onClick={this.props.viewAnnualBenefits}>View all Benefits</a></p>
                      </aside>
                      {/* <aside className='save-total'>
                        <h3><span>Up to <strong>$93.15</strong> <i>total savings</i></span></h3>
                      </aside> */}
                      <aside className="select-btn-group">
                        {/* <Link onClick={this.props.selectPlan} className="flex-btn" exact to={"/useraccount"} title='SELECT PLAN'><span>SELECT PLAN</span></Link> */}
                        <a onClick={this.props.selectPlan} className="flex-btn" href='javascript:;' title='SELECT PLAN'><span>SELECT PLAN</span></a>
                      </aside>
                    </li>
                    <li className={`col-md-6 col-sm-12 col-12 ${this.props.state.monthly_ActiveClass ? 'active':''}`}>
                      <aside className='content' onClick={(e) => this.props.choosePlans(e, this.props.getPrice(this.props.state.billingGetPriceObj[0].monThu, this.props.state.billingGetPriceObj[0].allday, this.props.state.billingGetPriceObj[0].visits, this.props.state.billingGetPriceObj[0].guests, 'monthly', this.props.state.billingGetPriceObj[0].type), 'monthly')}>
                        <h2>Monthly 
                          {
                            this.props.state.billingGetPriceObj.length > 0 &&
                            <span>${this.props.getPrice(this.props.state.billingGetPriceObj[0].monThu, this.props.state.billingGetPriceObj[0].allday, this.props.state.billingGetPriceObj[0].visits, this.props.state.billingGetPriceObj[0].guests, 'monthly', this.props.state.billingGetPriceObj[0].type)}<i>/mo <sup>1</sup></i></span>
                          }
                        </h2>
                        <p>Get a free upgrade to a PLATINUM Membership in CMX Rewards</p>
                        <p>No convenience or blockbuster fees and no upgrade charges to watch 3D, PLF, and Dolby ATMOS</p>
                        <p>10% Food and Beverage Discount<sup>3</sup></p>
                        <p className='text-center'><a href='javascript:;' onClick={this.props.viewMonthlyBenefits}>View all Benefits</a></p>
                      </aside>
                      {/* <aside className='save-total'>
                        <h3><span>Up to <strong>$93.15</strong> <i>total savings</i></span></h3>
                      </aside> */}
                      <aside className="select-btn-group">
                        {/* <Link onClick={this.props.selectPlan} className="flex-btn" exact to={"/useraccount"} title='SELECT PLAN'><span>SELECT PLAN</span></Link> */}
                        <a onClick={this.props.monthlySelectPlan} className="flex-btn" href='javascript:;' title='SELECT PLAN'><span>SELECT PLAN</span></a>
                      </aside>
                    </li>
                  </ul>
                </section>
                <section className='tc-contions'>
                  <ul>
                    <li><p><sup>1</sup> <span>Four month minimum commitment before you can cancel.</span></p></li>
                  </ul>
                  <ul>
                    {/* <li><p><sup>2</sup> <span>Excludes IMAX and DBOX</span></p></li> */}
                    <li><p><sup>2</sup> <span>Excludes IMAX and DBOX formats. No fees apply to Passport Credits only. Other fees apply to full-priced tickets.</span></p></li>
                  </ul>
                  <ul>
                    <li><p><sup>3</sup> <span>Exclude Alcoholic Beverages</span></p></li>
                    <li><p><span>Must remain in CMX Passport to receive the higher levels of rewards.</span></p></li>
                    <li><p><span>Prices subject to change.</span></p></li>
                    <li><p><span>Learn more about <a onClick={this.CMXRewards} href="javascript:;" title='CMX Rewards'>CMX Rewards</a></span></p></li>
                  </ul>
                </section>
              </section>
            </section>
          </section>
      </section>
    )
  }
}

export default Billing;
